import { render, staticRenderFns } from "./PromotionsCandidateItem.vue?vue&type=template&id=3fbcc518"
import script from "./PromotionsCandidateItem.vue?vue&type=script&lang=js"
export * from "./PromotionsCandidateItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports